import {env} from './EnvirementConfig';
class PrefixPath{
    static APP_NAME = 'AAM';
    static API_BASE_URL = env.API_ENDPOINT_URL
    static LOCATION_API_BASE_URL = env.LOCATION_API_URL;
    static HUB_API_BASE_URL = env.HUB_API_ENDPOINT_URL;
    static App_URL = env.REACT_APP;
    static APP_PREFIX_PATH = '/app';
    static AUTH_PREFIX_PATH = '/auth';
    static PAYA_DEVELOPER_ID = env.PAYA_DEVELOPER_ID;
    static PAYA_HASH_KEY = env.PAYA_HASH_KEY;
    static PAYA_USER_ID = env.PAYA_USER_ID;
    static PAYA_LOCATION_ID = env.PAYA_LOCATION_ID;
    static PAYA_CC_PRODUCT_TRANSACTION_ID = env.PAYA_CC_PRODUCT_TRANSACTION_ID;
    static PAYA_ACH_PRODUCT_TRANSACTION_ID = env.PAYA_ACH_PRODUCT_TRANSACTION_ID;
    static PAYA_BASE_URL = env.PAYA_BASE_URL;
}
export default PrefixPath;